import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CreateSimXUserAgreementRequest } from '../models/requests/create-simx-user-agreement-request.model';
import { GetSimXAgreementsRequest } from '../models/requests/get-simx-agreements-request.model';
import { CreateSimXUserAgreementResponse } from '../models/responses/create-simx-user-agreement-response.model';
import { DeleteSimXUserAgreementResponse } from '../models/responses/delete-simx-user-agreement-response.model';
import { GetSimXAgreementsResponse } from '../models/responses/get-simx-agreements-response.model';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class UserAgreementDataService {
  private readonly _dataService = inject(DataService);
  private readonly _http = inject(HttpClient);

  getUserAgreementsForAgreement(
    agreementId: string,
    request: GetSimXAgreementsRequest = {},
  ): Observable<GetSimXAgreementsResponse> {
    const url = this._dataService.userAgreementsForAgreementUrl(agreementId);
    return this._http.post<GetSimXAgreementsResponse>(url, request);
  }

  getUserAgreementsForUser(
    userId: string,
    request: GetSimXAgreementsRequest = {},
  ): Observable<GetSimXAgreementsResponse> {
    const url = this._dataService.userAgreementsForUserUrl(userId);
    return this._http.post<GetSimXAgreementsResponse>(url, request);
  }

  createUserAgreement(
    request: CreateSimXUserAgreementRequest,
  ): Observable<CreateSimXUserAgreementResponse> {
    const url = this._dataService.userAgreementsUrl();
    return this._http.put<CreateSimXUserAgreementResponse>(url, request);
  }

  deleteUserAgreement(
    userAgreementId: string,
  ): Observable<DeleteSimXUserAgreementResponse> {
    const url = this._dataService.userAgreementsUrl(userAgreementId);
    return this._http.delete<DeleteSimXUserAgreementResponse>(url);
  }
}
